<template>
        <!-- 消息 -->
        <div class="myMessage fl">
            <a href="JavaScript:;" @click="messageShow =!messageShow">
                <div class="myMessagenum" v-if="unreadMessagesNum!=0">{{unreadMessagesNum}}</div>
                <i class="iconfont">&#xe61f;</i>
            </a>
            <transition name="fade">
                <div class="messageBox" v-show="messageShow">
                    <div class="title">消息（{{unreadMessagesNum}}）</div>
                    <ul class="clearfix">
                        <li v-for="item in messageList" :key="item.id">
                            <a href="javascript:;">
                                <div class="fl"><i class="iconfont">&#xe6de;</i></div>
                                <div class="messageinfo">
                                    <h6>{{item.title}}</h6>
                                    <div class="messagebot clearfix">
                                        <div class="fl">{{item.readTime}}</div>
                                        <div class="fr" @click="reads(item.id)">我知道了</div>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <a href="javascript:;">查看更多</a>
                </div>
            </transition>
        </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {getUnReadList,reads,getUnReadCount} from "@/utils/api-im"
    export default {
        name: "message",
        data(){
            return{
                messageShow:false,
                messageList:[],//消息列表
                unreadMessagesNum:0,
            }
        },
        computed:{
            ...mapGetters('im',{
                navbardata:'currentUser'
            })
        },
        methods:{
            //获取五个
            getUnReadList(){
                let data={
                    "companyId":"22553",
                    "userId":"108450"
                }
                this.$post(getUnReadList,data).then((res)=>{
                    this.messageList=res.data.object;
                    this.getUnReadCount();
                })
            },
            //获取未读消息数量
            getUnReadCount(){
                let data={
                    "companyId":"22553",
                    "userId":"108450"
                }
                this.$post(getUnReadCount,data).then((res)=>{
                    console.log(res,'kyk',this.messageList)
                   this.unreadMessagesNum=res.data.object;
                })
            },
            //设置已读
            reads(id){
                let data={
                    "companyId":"22553",
                    "userId":"108450",
                    ids:[id]
                }
                this.$post(reads,data).then((res)=>{
                    console.log(res)
                    this.getUnReadList();
                })
            }
        },
        mounted() {
            //测试时可能有，实际上组件第一次加载时需要监听获取

            console.log(this.navbardata.user,"ymy")
            this.getUnReadList();

        }
    }
</script>

<style scoped lang="less">
    .myMessage {

        .messageBox {
            width: 280px;
            background: #fff;
            background-clip: padding-box;
            border: 1px solid rgba(0, 0, 0, 0.2);
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
            position: absolute;
            top: 58px;
            left: -220px;
            z-index: 9999;

            li {
                float: initial;
                border-bottom: 1px solid #eee;
                height: 56px;
            }

            a {
                color: #000000;
                display: block;
                padding-left: 20px;

            &>.fl {
                 height: 56px;
                 width: 40px;

            i{
                border-radius: 20px;
                padding: 5px 6px;
                background: #0099ff;
                color: #fff;
                font-size: 26px;
            }
        }

        .messageinfo {
            width: 190px;
            height: 56px;
            float: left;
            font-size: 12px;

            h6{
                font-weight: 500;
                height: 20px;
                line-height: 20px;
                margin-top: 7px;
            }

            .messagebot{
                height: 20px;
                line-height: 20px;
                color: #777;
            }
        }
        }

        &>a{
             height: 30px;
             line-height: 30px;
             text-align: center;

        &:hover{
             color: #0099ff;
         }
        }

        }

        .title {
            background: #24252a;
            color: #fff;
            height: 40px;
            line-height: 40px;
            padding: 0 10px;
            text-align: left;
        }
    }
    /**/
    .iconfont{
        font-size: 25px;
    }
    a {
        color: #fff;
        position: relative;

        .myMessagenum{
            position: absolute;
            top: 3px;
            left: 14px;
            padding: 2px 6px;
            height: 14px;
            line-height: 14px;
            font-size: 12px;
            border-radius: 16px;
            background: red;
            color: #fff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/message.vue